import iconCart from "../../assets/img/icon-cart.svg";
import iconOrder from "../../assets/img/icon-order.svg";
import iconSupport from "../../assets/img/icon-support.svg";
import iconArrow from "../../assets/img/icon-arrow.svg";
import iconGraph2 from "../../assets/img/icon-graph2.svg";
import iconAssortment from "../../assets/img/icon-assortment.svg";
import iconDollar from "../../assets/img/icon-dollar.svg";
import SignUpForm from "./../../components/shared/signUpForm/signUpForm.vue";

export default {
  components: {
    SignUpForm,
  },
  data() {
    return {
      activeView: null,
      model: {},
      retailer: {
        icon1: iconCart,
        iconWidth1: 62,
        header_1: "Discover New Products",
        text_1: "Browse a curated marketplace stocked with coveted items your customers will love.",
        icon2: iconOrder,
        iconWidth2: 44,
        header_2: "Order Management",
        text_2: "Shop hundreds of brands all in one place without pesky line-sheets, phone calls and emails.",
        icon3: iconSupport,
        iconWidth3: 52,
        header_3: "free returns",
        text_3: "If a new product doesn't sell in 60 days, you can send it right on back for free.",
      },
      brand: {
        icon1: iconArrow,
        iconWidth1: 48,
        header_1: "Wholesale Orders <br/> in a Snap",
        text_1: "Secure the bag with steady orders from vetted retailers across the country.",
        icon2: iconGraph2,
        iconWidth2: 110,
        header_2: "Quick n’ Easy <br/> Setup ",
        text_2: " We’ll craft your brand page, build your products and pitch your goods to our network of stores.",
        icon3: iconDollar,
        iconWidth3: 54,
        header_3: "Get Paid <br/>Upfront",
        text_3: "We pay you once your order ships – say bye-bye to overdue invoices and credit card debt.",
      },
      assortment: {
        icon1: iconCart,
        iconWidth1: 66,
        header_1: "Discover New <br/>Brands & Products",
        text_1:
          "Thousands of brands are boxed out of pricey tradeshows. Access products you won’t find anywhere else. ",
        icon2: iconAssortment,
        iconWidth2: 38,
        header_2: "Data-Driven <br/>Decisions",
        text_2: "Our Merchant Team analyzes your store data to source products your customers will love.",
        icon3: iconOrder,
        iconWidth3: 45,
        header_3: "Seamless <br/>Order Management",
        text_3: "Save time and shop your custom assortment line-sheet and email free.",
      },
    };
  },

  beforeMount() {
    // this.activeView = this.$route.params.view ? this.$route.params.view : 'brand';
    this.activeView = "retailer";
    this.updateModel();
  },
  methods: {
    scrollToRetailerSignupForm() {
      document.getElementById("retailer_signup_offset").scrollIntoView({ behavior: "smooth" });
    },
    updateModel: updateModel,
  },

  watch: {
    "$route.params.view": function (val) {
      this.activeView = val;
      this.updateModel();
    },
  },
};

function updateModel() {
  if (this.activeView === "brand") {
    this.model = this.brand;
  } else if (this.activeView === "retailer") {
    this.model = this.retailer;
  } else if (this.activeView === "assortment") {
    this.model = this.assortment;
  }
}

function openUnregisteredModal() {
  //  this.$eventBus.$emit('showQuickShopModalUnregistered', null);
  this.$eventBus.$emit("apply-modal-unregistered", null);
}
